<div *ngIf="isLoaderShown" class="loader-wrapper d-flex justify-content-center align-items-center">
    <div class="loader-container">
        <div class="loader">
            <ng-lottie width="200px" height="200px" [options]="loaderOptions"></ng-lottie>
        </div>
        <div *ngIf="isLoadingError" class="loader-info">There was an issue loading the webpage.<br /><a class="btn-link-primary" (click)="onReload()">Click here to reload the page.</a></div>
    </div>
</div>
